import React, { useEffect } from "react";
import SVG from "react-inlinesvg";
import { Modal } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../../../../../../../../../_metronic/_helpers";
import { formatAmount, formatDate, permissionAllow, transactionCat, transactionType, ucFirst } from "../../../../../../../../../../util/Helpers"
import { useApproveTransactionMutation, useDeclineTransactionMutation } from "../../../../../../../../../../../redux/apiSlice";
import cogoToast from "cogo-toast";
import { Permissions, PermissionType } from "../../../../../../../../../../util/Permissions";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import * as handlers from "../../../../../../../../_redux/selected-user/selectedUserHandlers";

const ViewTransactionModal = ({ showViewTransactionModal, details, onHide, tableRef }) => {
    const adminUser = useSelector(state => state.auth.user);
    const { userId, accountId } = useParams();
    const dispatch = useDispatch();
    // Approve And Decline Mutation
    const [approveTransaction, { isLoading: isApproving, isSuccess: approvedSuccessfully }] = useApproveTransactionMutation();
    const [declineTransaction, { isLoading: isDeclining, isSuccess: declineSuccessfully }] = useDeclineTransactionMutation();

    /* Close Modal on Successful Approval or Decline */
    useEffect(() => {
        if (approvedSuccessfully || declineSuccessfully) {
            cogoToast.success(`Transaction ${declineSuccessfully ? "Declined" : "Approved"} Successfully`);
            onHide();
            if (tableRef) {
                tableRef.current.refresh();
            }
            else if (userId && accountId) {
                dispatch(handlers.fetchUserAccountDetails(userId, accountId));
            }
        }
    }, [approvedSuccessfully, declineSuccessfully, onHide, dispatch, accountId, userId, tableRef]);

    return (
        <Modal
            show={showViewTransactionModal}
            onHide={onHide}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    <span
                        className={`svg-icon svg-icon-lg svg-icon-${details?.type === "DEPOSIT" ? "primary" : "danger"} mr-3`}>
                        <SVG
                            title=""
                            src={toAbsoluteUrl("/media/svg/icons/Shopping/Gift.svg")}
                        />
                    </span>
                    Transaction Details
                </Modal.Title>
                <button type="button" className="close" onClick={onHide}>
                    <span aria-hidden="true" className="d-block">×</span>
                    <span className="sr-only">Close</span>
                </button>
            </Modal.Header>
            <Modal.Body
                className="px-10 pt-2 pb-5"
            >
                <div className="row">
                    <div className="col-lg py-4">
                        <h6 className=" px">AutoId</h6>
                        <span className="text-muted">{details?.autoId}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6 className=" px">Ref Id</h6>
                        <span className="text-muted">{details?.refId ?? "Nil"}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg py-4">
                        <h6 className=" px">Status</h6>
                        <span className="text-muted">{details?.tranStatus?.toUpperCase()}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6 className=" px">Amount</h6>
                        <span className="text-muted">{formatAmount(details?.currency, details?.tranAmount)}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6 className=" px">Transaction Type</h6>
                        <span className="text-muted"> {transactionType(details)} <span className="small pl-2"> ({transactionCat(details)})</span> </span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg py-4">
                        <h6 className=" px">Partner</h6>
                        <span className="text-muted">{ucFirst(details?.partner)}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6 className=" px">Updated At</h6>
                        <span className="text-muted">{formatDate(details?.updated)}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6 className=" px">Created At</h6>
                        <span className="text-muted">{formatDate(details?.created)}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg py-4">
                        <h6 className=" px">Description</h6>
                        <span className="text-muted">{details?.comment ?? "Nil"}</span>
                    </div>
                </div>
                {
                    details?.failureReason &&

                    <div className="row">
                        <div className="col-lg py-4">
                            <h6 className="text-danger">Error Message</h6>
                            <span className="text-muted">{details.failureReason}</span>
                        </div>
                    </div>
                }
                <div className="row">
                    <div className="col-lg">
                        <h4 className="mb-4 pt-5 mt-5 text-muted h5">More Details</h4>
                        <div className="text-muted bg-light-secondary rounded-lg p-4 overflow-auto" style={{ maxHeight: "300px" }}>
                            <pre className="mb-0">{JSON.stringify(details?.meta, null, 4)}</pre>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                {
                    (

                        details?.tranType !== "sell" && details?.tranType !== "buy" && details?.tranStatus === "pending" &&
                        permissionAllow(adminUser, Permissions.TRANSACTIONS, PermissionType.UPDATE)
                    ) ? <>
                        <button
                            type="button"
                            disabled={isApproving || isDeclining}
                            onClick={_ => approveTransaction({ id: details?.autoId, accountId: details?.accountId, userId: details.userId, userGroup: details.userGroup, meta: details })}
                            className={`btn btn-primary btn-elevate px-5`}
                        >
                            Approve
                        </button>
                        <button
                            type="button"
                            disabled={isApproving || isDeclining}
                            onClick={_ => declineTransaction({ id: details?.autoId, accountId: details?.accountId, userId: details.userId, userGroup: details.userGroup, meta: details })}
                            className={`btn btn-danger btn-elevate px-5 ml-5`}
                        >
                            Decline
                        </button>
                    </>
                        : <>
                            <button
                                type="button"
                                onClick={onHide}
                                className="btn btn-secondary btn-elevate px-5"
                            >
                                Okay
                            </button>
                        </>
                }

            </Modal.Footer>
        </Modal>

    );
}

export default ViewTransactionModal;